const createToast = ({ message = '', title = '', type, onClose, delay = 5000, url }) => {
  // 1. Create the Toast container (if it doesn't exist)
  let toastContainer = document.querySelector('#toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    toastContainer.className = 'toast-container position-fixed top-0 end-0 p-3';
    document.body.appendChild(toastContainer);
  }

  // 2. Create the Toast HTML structure
  const toastEl = document.createElement('div');
  toastEl.className = 'toast';
  toastEl.setAttribute('role', 'alert');
  toastEl.setAttribute('aria-live', 'assertive');
  toastEl.setAttribute('aria-atomic', 'true');
  if (delay) toastEl.setAttribute('data-bs-delay', delay);

  const typeClass =
    {
      danger: 'text-bg-danger',
      error: 'text-bg-danger',
      warning: 'text-bg-warning',
      info: 'text-bg-info',
      success: 'text-bg-success'
    }[type] || '';

  const actions =
    (url &&
      `<div class="mt-2 pt-2 border-top text-end">
      <a href="${url}" class="btn btn-primary btn-sm">${I18n.t('show')}</a>
        </div> `) ||
    '';

  const body = message ? `<div class="toast-body">${message} ${actions}</div>` : '';

  toastEl.innerHTML = `
    <div class="toast-header ${typeClass}">
      <strong class="me-auto">${title}</strong>
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    ${body}
  `;

  // 3. Append to container
  toastContainer.appendChild(toastEl);

  // 4. Initialize and show (Bootstrap 5 syntax)
  const toast = new globalThis.bootstrap.Toast(toastEl);
  toast.show();

  // Optional: Remove from DOM after it hides to keep things clean
  toastEl.addEventListener('hidden.bs.toast', () => {
    toastEl.remove();
    onClose && onClose();
  });
};

export default createToast;
